function recursiveSetValues (subObjects, remarkOptions, inspectionRows, taskItem) {
    const itemsToRemove = []
    for(const subObject of subObjects){
        if(subObject.SubObjects){
            subObject.SubObjects = recursiveSetValues(subObject.SubObjects, remarkOptions, inspectionRows, taskItem)
        }
        else{
            
            const soIndex = inspectionRows.findIndex((obj => obj.ServiceObjectId == subObject.Id));
            if(soIndex>= 0){
                var rmo = remarkOptions["default"];
                if(remarkOptions[subObject.EquipmentType]){
                    rmo = remarkOptions[subObject.EquipmentType]
                }
                subObject["RemarkOptions"] = rmo;
                subObject["LocationId"] = taskItem.Location.Id
                const soIndex = inspectionRows.findIndex((obj => obj.ServiceObjectId == subObject.Id));
                for (const [key, value] of Object.entries(inspectionRows[soIndex])) {
                    subObject[key] = value 
                }

                if(subObject["InspectionStatus"] === 1 || subObject["InspectionStatus"] === 2)
                    subObject["Hidden"] = true 
                else
                    subObject["Hidden"] = false 
            }
            else{
                itemsToRemove.push(subObject.Id)
            }
        }
    }
    for(const id of itemsToRemove){
        const index = subObjects.findIndex((obj => obj.ServiceObjectId == id));
        if(index >= 0){
            subObjects.splice(index, 1);
        }
    }

    return subObjects;
  }

  function recursiveGetValues (subObjects){
    var list = []
    for(const subObject of subObjects){
        if(subObject.SubObjects){
            list = list.concat(recursiveGetValues(subObject.SubObjects))
        }
        else{
            if(subObject.InspectionStatus != undefined && subObject.Hidden != undefined){
                if(subObject.Hidden && subObject.InspectionStatus == 1){
                  list.push(true)
                }
                else if(subObject.Hidden && subObject.InspectionStatus == 2 && subObject.Remark != undefined && subObject.Remark != ""){
                    list.push(true)
                }
                else{
                    list.push(false)
                }
              }else{
                list.push(false)
              }
        }
    }
    return list
  }
  module.exports = {
    recursiveSetValues,
    recursiveGetValues
  }
  